<template lang="pug"></template>

<script>
export default {
    name: 'BotaoMonitoramentoAgricola',
    componentOptions: {
        title: 'MonitoramentoAgricola',
        actions: [
            [
                {
                    name: 'Monitoramento Agrícola',
                    iconClass: 'lyra-icon lyra-agricola',
                    showView: false,
                    action: 'abrirMonitoramentoAgricola',
                    route: 'MonitoramentoAgricola',
                    isNew: true,
                    nameTranslationKey:
                        'mensagens.menuLateral.monitoramentoAgricola'
                }
            ]
        ]
    },

    methods: {
        abrirMonitoramentoAgricola() {
            if (this.$route.name !== 'MonitoramentoAgricola') {
                this.$router.push({ name: 'MonitoramentoAgricola' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
